import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
import { generateURL } from "../utilities";
// import Cookies from "universal-cookie";

// const cookies = new Cookies();
const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

// export const getOrdersList = async (data) => {
//     // let q = key.queryKey[1];
//     // let token = cookies.get(TOKEN_KEY);
//     let fd = new FormData()
//     for (var key in data) {
//         fd.append(key, data[key]);
//     }
//     let res = await axios({ method: "POST", data: fd,  url: `${API_ENDPOINT}orderlist`, headers: { Authorization: getToken() ? `Bearer ${getToken()}` : '', } })
//     return res
// };

export const getOrdersList = async () => {
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}orders/list`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const getOrderDetails = async (id) => {
  let res = await axios({
    method: "GET",
    url: `${API_ENDPOINT}orders/fetch_order_items?order_id=${id}`,
    headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
  });
  return res;
};

export const getOrderPdf = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "post",
    url: `${API_ENDPOINT}orders/invoice`,
    data: fd,
    responseType: "blob",
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Content-Type": "application/json",
    },
  });
  return res;
};

/**
 * Export orders with the same filters as the list API.
 * @param {Object} params - Same filter params as orders/list (order_id, name, phone, order_date_from, order_date_to, total_sum, paymentModeFilter, delivery_status). Optionally limit for export size.
 * @returns {Promise<AxiosResponse>} Response with responseType: 'blob' for file download.
 */
export const exportOrders = async (params) => {
  const fd = new FormData();
  const exportParams = { ...params };
  if (exportParams.pageNo !== undefined) delete exportParams.pageNo;
  exportParams.limit = exportParams.limit ?? 9999;
  for (const key in exportParams) {
    if (exportParams.hasOwnProperty(key) && exportParams[key] !== undefined && exportParams[key] !== null) {
      fd.append(key, exportParams[key]);
    }
  }
  const res = await axios({
    method: "post",
    url: `${API_ENDPOINT}orders/export${generateURL(exportParams)}`,
    data: fd,
    responseType: "blob",
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
    },
  });
  return res;
};

export const updateOrderDeliveryStatus = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "post",
    url: `${API_ENDPOINT}orders/set_delivery_status`,
    data: fd,
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const removeOrderDeliveryStatus = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "post",
    url: `${API_ENDPOINT}orders/remove_delivery_status`,
    data: fd,
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const removeOrderStatus = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "post",
    url: `${API_ENDPOINT}orders/remove_order_status`,
    data: fd,
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Content-Type": "application/json",
    },
  });
  return res;
};

export const setOrderStatus = async (data) => {
  let fd = new FormData();
  for (var key in data) {
    fd.append(key, data[key]);
  }
  let res = await axios({
    method: "post",
    url: `${API_ENDPOINT}orders/set_order_status`,
    data: fd,
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
      "Content-Type": "application/json",
    },
  });
  return res;
};
